<template>
    <div class="md-layout" v-if="isFileBan">
        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
            <traffic-light-card
                title="File Ban"
                showTooltip
                :status="file_ban()"
            >
                <traffic-light-item>
                {{ error.detail }}
                </traffic-light-item>
            </traffic-light-card>
        </div>
    </div>

    <div class="md-layout" v-else-if="vedaReport.success && !vedaReport.is_credit_file_outdated">

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
            <traffic-light-card
                title="Credit Score"
                showTooltip
                :status="credit_score_status(vedaReport.credit_score)"
            >
                <traffic-light-item secondary="2.0">
                {{ vedaReport.credit_score.v_20 }}
                </traffic-light-item>
                <traffic-light-item secondary="1.1">
                {{ vedaReport.credit_score.v_11 }}
                </traffic-light-item>
            </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="Insolvency"
            showTooltip
            :status="insolvency_status(vedaReport.insolvency)"
        >
            <traffic-light-item>
            {{ vedaReport.insolvency.value }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="One Score"
            showTooltip
            :status="credit_score_status(vedaReport.credit_score)"
        >
            <traffic-light-item
            secondary="1.0"
            v-if="vedaReport.credit_score.v_10 != '' && vedaReport.credit_score.v_10 != null"
            >
            {{ vedaReport.credit_score.v_10 }}
            </traffic-light-item>
            <loading-icon-text-button
            v-if="(vedaReport.credit_score.v_10 == '' || vedaReport.credit_score.v_10 == null)
            && userHasPermission('request veda')"
            :disabled = "!activeOneScoreButton"
            @click="$emit('click-one-score', $event)"
            icon="get_app"
            >
            Get
            </loading-icon-text-button>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="Payday Enquiries"
            showTooltip
            :status="payday_enquiries_status(vedaReport.payday_enquiries)"
            @click="showVedaDetailsDialog('veda-details-payday-enquiries')"
        >
            <traffic-light-item secondary="In 6 months">
            {{ vedaReport.payday_enquiries.value | truth }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="Financial Defaults"
            showTooltip
            :status="financial_defaults_status(vedaReport.financial_defaults)"
            @click="showVedaDetailsDialog('veda-details-financial-defaults')"
        >
            <traffic-light-item :secondary="`${vedaReport.financial_defaults.paid_count} Paid`">
            {{ vedaReport.financial_defaults.paid_value | currency(0) }}
            </traffic-light-item>
            <traffic-light-item :secondary="`${vedaReport.financial_defaults.unpaid_count} Unpaid`">
            {{ vedaReport.financial_defaults.unpaid_value | currency(0) }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="Non Financial Defaults"
            showTooltip
            :status="non_financial_defaults_status(vedaReport.non_financial_defaults)"
            @click="showVedaDetailsDialog('veda-details-non-financial-defaults')"
        >
            <traffic-light-item :secondary="`${vedaReport.non_financial_defaults.paid_count} Paid`">
            {{ vedaReport.non_financial_defaults.paid_value | currency(0) }}
            </traffic-light-item>
            <traffic-light-item :secondary="`${vedaReport.non_financial_defaults.unpaid_count} Unpaid`">
            {{ vedaReport.non_financial_defaults.unpaid_value | currency(0) }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="Judgements"
            showTooltip
            @click="showVedaDetailsDialog('veda-details-judgements')"
            :status="judgement_status(vedaReport.judgements)"
        >
            <traffic-light-item secondary="Total">
            {{ vedaReport.judgements.total_count }}
            </traffic-light-item>
            <traffic-light-item :secondary="`${vedaReport.judgements.unpaid_count} Unpaid`">
            {{ vedaReport.judgements.unpaid_value | currency(0) }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="Worst CCR"
            showTooltip
            :status="ccr_status(vedaReport.ccr)"
            @click="showVedaDetailsDialog('veda-details-ccr')"
        >
            <traffic-light-item secondary="Last 12 months">
            {{ computed_ccr_worst_status['12m'] }}
            </traffic-light-item>
            <traffic-light-item secondary="Last 24 months">
            {{ computed_ccr_worst_status['24m'] }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="Credit Shopping"
            showTooltip
            :status="credit_shopping_status(vedaReport.credit_shopping)"
            @click="showVedaDetailsDialog('veda-details-credit-shopping')"
        >
            <traffic-light-item :secondary="`${vedaReport.credit_shopping.count} Enquiries`">
            {{ vedaReport.credit_shopping.value | truth }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div v-if="abn" class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
            title="ABN"
            showTooltip
            bannerMessage="Beta"
            :status="abn_status(vedaReport.abn.abn_traffic_light)"
            @click="showVedaDetailsDialog('veda-details-abn')"
        >
            <traffic-light-item>
            {{ abn_traffic_color }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
        title="Directorships"
        :status="directorships_status(vedaReport.user_details.directorships)"
        @click="showVedaDetailsDialog('veda-details-directorships')"
        >
            <traffic-light-item :secondary="`${vedaReport.user_details.directorships.count} Directorships`">
                {{ vedaReport.user_details.directorships.value | truth }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div v-if="vedaReport.age_of_file.months !== null" class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
        title="Age of File"
        :status="age_of_file_status(vedaReport)"
        @click="showVedaDetailsDialog('veda-details-age-of-file')"
        >
            <traffic-light-item>
                {{ vedaReport.age_of_file.readable }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div v-if="hasFhisData" class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
        title="Financial Hardship"
        :status="fhis_status(vedaReport.user_details.fhis)"
        @click="showVedaDetailsDialog('veda-details-fhis')"
        >
            <traffic-light-item :secondary="`Hardship Evident`">
                {{ fhis_status(vedaReport.user_details.fhis, true) }}
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <div v-else-if="!hasFhisData" class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25">
        <traffic-light-card
        title=""
        :status="fhis_status(vedaReport.user_details.fhis)"
        >
            <traffic-light-item>
            </traffic-light-item>
        </traffic-light-card>
        </div>

        <md-dialog class="dialog" :md-active.sync="show_veda_details_dialog" md-close-on-esc md-click-outside-to-close>
        <!-- <md-dialog-title>Veda Report Summary Details</md-dialog-title> -->

        <md-tabs class="tabs-with-title md-transparent" md-alignment="right" md-dynamic-height :md-active-tab="current_veda_details_dialog_tab">
            <!-- This first tab is used as a dialog title -->
            <md-tab id="veda-details" md-label="Veda Report Summary" md-disabled />

            <md-tab id="veda-details-payday-enquiries" md-label="Payday Enquiries">
            <md-dialog-content class="md-layout">
                <table class="data-table md-layout-item md-alignment-center-center">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Enquirer</th>
                    <th>Account Type</th>
                    <th>Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="enquiry in vedaReport.payday_enquiries.enquiries">
                    <td>{{ enquiry.enquiry_date }}</td>
                    <td>
                    <p> {{ enquiry.credit_enquirer }}</p>
                    <p class="light">{{ enquiry.credit_enquirer_classification }}</p>
                    </td>
                    <td>
                    <p> {{ enquiry.account_type }}</p>
                    <p class="light">{{ enquiry.account_type_code }}</p>
                    </td>
                    <td>{{ enquiry.enquiry_amount | currency }}</td>
                </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-credit-shopping" md-label="Credit Shopping">
            <md-dialog-content class="md-layout">
                <table class="data-table md-layout-item md-alignment-center-center">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Enquirer</th>
                    <th>Account Type</th>
                    <th>Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="enquiry in vedaReport.credit_shopping.enquiries">
                    <td>{{ enquiry.enquiry_date }}</td>
                    <td>
                    <p> {{ enquiry.credit_enquirer }}</p>
                    <p class="light">{{ enquiry.credit_enquirer_classification }}</p>
                    </td>
                    <td>
                    <p> {{ enquiry.account_type }}</p>
                    <p class="light">{{ enquiry.account_type_code }}</p>
                    </td>
                    <td>{{ enquiry.enquiry_amount | currency }}</td>
                </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-financial-defaults" md-label="Financial Defaults">
            <md-dialog-content class="md-layout">
                <table class="data-table md-layout-item md-alignment-center-center">
                <thead>
                <tr>
                    <th>Date/Status</th>
                    <th>Current/Original</th>
                    <th>Creditor</th>
                    <th>Account Type</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="_default in vedaReport.financial_defaults.defaults">
                    <td>
                    <p>{{ _default.status_date }}</p>
                    <p>{{ _default.status }}</p>
                    </td>
                    <td>
                    <p>              {{ _default.current_default.default_amount | currency }}</p>
                    <p class="light">{{ _default.original_default.default_amount | currency }}</p>
                    </td>
                    <td>
                    <p>              {{ _default.account.name }}</p>
                    <p class="light">{{ _default.account.classification }}</p>
                    </td>
                    <td>
                    <p>              {{ _default.account.account_type }}</p>
                    <p class="light">{{ _default.account.account_type_code }}</p>
                    </td>
                </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-non-financial-defaults" md-label="Non Financial Defaults">
            <md-dialog-content class="md-layout">
                <table class="data-table md-layout-item md-alignment-center-center">
                <thead>
                <tr>
                    <th>Date/Status</th>
                    <th>Current/Original</th>
                    <th>Creditor</th>
                    <th>Account Type</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="_default in vedaReport.non_financial_defaults.defaults">
                    <td>
                    <p>{{ _default.status_date }}</p>
                    <p>{{ _default.status }}</p>
                    </td>
                    <td>
                    <p>              {{ _default.current_default.default_amount | currency }}</p>
                    <p class="light">{{ _default.original_default.default_amount | currency }}</p>
                    </td>
                    <td>
                    <p>              {{ _default.account.name }}</p>
                    <p class="light">{{ _default.account.classification }}</p>
                    </td>
                    <td>
                    <p>              {{ _default.account.account_type }}</p>
                    <p class="light">{{ _default.account.account_type_code }}</p>
                    </td>
                </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-judgements" md-label="Judgements">
                <md-dialog-content class="md-layout">
                    <table class="data-table md-layout-item md-alignment-center-center">
                        <thead>
                        <tr>
                            <th>Total Count</th>
                            <th>Unpaid Count</th>
                            <th>Unpaid Value</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{vedaReport.judgements.total_count}}</td>
                            <td>{{vedaReport.judgements.unpaid_count}}</td>
                            <td>{{vedaReport.judgements.unpaid_value}}</td>
                        </tr>
                        </tbody>
                    </table>
                </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-ccr" md-label="CCR">
            <md-dialog-content class="md-layout">
                <table class="data-table dense colum-border md-layout-item md-alignment-center-center">
                <thead>
                    <tr>
                    <th>Years / Type</th>
                    <th v-for="{ year, months } of computed_ccr_dates" :colspan="months.length" class="text-center">{{ year }}</th>
                    </tr>
                    <tr>
                    <th>Month</th>
                    <template v-for="{ months } of computed_ccr_dates">
                        <th v-for="month of months" class="text-center">{{ month }}</th>
                    </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="account of vedaReport.ccr.accounts">
                    <td>{{ account.type }}</td>
                    <td v-for="status of account.repayment_history" class="text-center">
                        <span class="ccr_color" :class="{
                        passive: 'CRPOTA'.includes(status),
                        good:    '01'.includes(status),
                        neutral: '2'.includes(status),
                        bad:     '3456X'.includes(status),
                        }">
                        {{ status }}
                        </span>
                        <md-tooltip md-delay="300" v-if="status == 0">  0: Up to date</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 1">  1: 0-29 days overdue</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 2">  2: 30-59 days overdue</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 3">  3: 60-89 days overdue</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 4">  4: 90-119 days overdue</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 5">  5: 120-149 days overdue</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 6">  6: 150-179 days overdue</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 'X'">X: 180+ days overdue</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 'C'">C: Closed</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 'R'">R: Not Reported</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 'P'">P: Pending</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 'A'">A: Not Associated</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 'O'">O: Other</md-tooltip>
                        <md-tooltip md-delay="300" v-if="status == 'T'">T: Transferred</md-tooltip>
                    </td>
                    </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-fhis" md-label="FHI">
            <md-dialog-content class="md-layout">
                <table class="data-table dense colum-border md-layout-item md-alignment-center-center">
                <thead>
                    <tr>
                    <th>Years / Type</th>
                    <th v-for="{ year, months } of computed_fhis_dates" :colspan="months.length" class="text-center">{{ year }}</th>
                    </tr>
                    <tr>
                    <th>Month</th>
                    <template v-for="{ months } of computed_fhis_dates">
                        <th v-for="month of months" class="text-center">{{ month }}</th>
                    </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="account of vedaReport.ccr.accounts">
                    <td>{{ account.type }}</td>
                    <td v-for="status of getLast12MonthsOfFhis(account.repayment_history_v_status)" class="text-center">
                        <span class="ccr_color" :class="{
                        good:    status.data_field_value === null,
                        neutral: 'A'.includes(status.data_field_value),
                        bad:     'V'.includes(status.data_field_value),
                        }">
                        {{ formatFhisText(status.data_field_value) }}
                        </span>
                        <md-tooltip md-delay="300" v-if="status.data_field_value === null">  -: No Hardship Indicated</md-tooltip>
                        <md-tooltip md-delay="300" v-else-if="status.data_field_value === 'A'">  A: Temporary Hardship Agreement</md-tooltip>
                        <md-tooltip md-delay="300" v-else-if="status.data_field_value === 'V'">  V: Permanent Hardship Agreement</md-tooltip>
                    </td>
                    </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-abn" md-label="ABN">
            <md-dialog-content class="md-layout">
                <table class="data-table md-layout-item md-alignment-center-center">
                <thead>
                <tr>
                    <th>ABN Number</th>
                    <th>ABN Active Date</th>
                    <th>GST Registered Date</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{vedaReport.abn.abn_number}}</td>
                    <td>{{vedaReport.abn.abn_active_date}}</td>
                    <td>{{vedaReport.abn.gst_registered_date}}</td>
                </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-directorships" md-label="Directorships">
            <md-dialog-content class="md-layout">
                <table class="data-table md-layout-item md-alignment-center-center">
                <thead>
                <tr>
                    <th>Date Appointed</th>
                    <th>Date Ceased</th>
                    <th>Duration</th>
                    <th>Name</th>
                    <td>Type</td>
                    <td>ABN</td>
                </tr>
                </thead>
                <tbody v-if="directorships.length">
                <tr v-for="(directorship, key) in directorships" :key="key">
                    <td>{{directorship.date_appointed.formatted}}</td>
                    <td>{{directorship.date_ceased.formatted}}</td>
                    <td>{{directorship.duration.years}} years {{directorship.duration.months}} months ago</td>
                    <td>{{directorship.employer_details.name}}</td>
                    <td>{{directorship.employer_details.type}}</td>
                    <td>{{directorship.employer_details.abn}}</td>
                </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
            <md-tab id="veda-details-age-of-file" md-label="Age of File">
            <md-dialog-content class="md-layout">
                <table class="data-table md-layout-item md-alignment-center-center">
                <thead>
                <tr>
                    <th>ABN Number</th>
                    <th>ABN Active Date</th>
                    <th>GST Registered Date</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{vedaReport.abn.abn_number}}</td>
                    <td>{{vedaReport.abn.abn_active_date}}</td>
                    <td>{{vedaReport.abn.gst_registered_date}}</td>
                </tr>
                </tbody>
                </table>
            </md-dialog-content>
            </md-tab>
        </md-tabs>

        <md-dialog-actions>
            <md-button class="md-primary md-simple" @click="show_veda_details_dialog = false">Close</md-button>
        </md-dialog-actions>

        </md-dialog>

        <!-- Open Veda Report -->
        <div class="md-layout-item md-size-100">
        <!-- Full Report Button -->
        <md-button class="md-primary" :href="report_pdf_url" target="_blank" v-if="showFullReportButton">Full Report</md-button>

        <!-- Put component here -->
        <send-to-perfect-score-request v-if="showPerfectScoreButton && ($store.state.user.primary_roles.includes('super-admin') || $store.state.user.primary_roles.includes('Broker'))"></send-to-perfect-score-request>

        <!-- Possible Matches Button -->
        <md-button
            class="md-danger"
            @click="show_possible_matches"
            v-if="showActionButtons && (vedaReport.possible_matches.count > 0 && !vedaReport.cross_matches) && version === 'Current'"
        >
            Show Possible Matches
        </md-button>

        <loading-icon-text-button
            class="md-danger"
            @click="requestOriginalCreditReport(vedaReport.cross_matches.id)"
            icon="autorenew"
            :loading="isOriginalCreditReportRequested"
            :disabled="isOriginalCreditReportRequested"
            v-if="showActionButtons && (vedaReport.cross_matches && !vedaReport.original)"
        >
            Show Original Credit Report
        </loading-icon-text-button>

        <loading-icon-text-button
            class="md-danger"
            @click="requestCrossMatchCreditReport(vedaReport.cross_matches.id)"
            icon="autorenew"
            :loading="isOriginalCreditReportRequested"
            :disabled="isOriginalCreditReportRequested"
            v-if="showActionButtons && (vedaReport.cross_matches && vedaReport.original)"
        >
            Show Cross Match Credit Report
        </loading-icon-text-button>

        </div>

        <!-- Possible Matches Dialog Starts -->
        <md-dialog
        :md-active.sync="show_possible_matches_dialog"
        :md-click-outside-to-close="false"
        :md-close-on-esc="false"
        class="show_possible_matches_dialog"
        >
        <md-dialog-title> Possible Matches</md-dialog-title>
        <md-dialog-content>
            <div
            class="md-layout md-size-100"
            v-for="possible_match in vedaReport.possible_matches.data"
            :key="possible_match.id"
            >
            <div class="md-layout-item md-size-70">
                First Name: <strong>{{ possible_match.first_given_name }}</strong>
                <br />
                Middle Name: <strong>{{ possible_match.other_given_name }}</strong>
                <br />
                Last Name: <strong>{{ possible_match.family_name }}</strong> <br />
                Gender: <strong>{{ possible_match.gender }}</strong> <br />
                Date of Birth: <strong>{{ possible_match.date_of_birth }}</strong>
                <br />
            </div>
            <div class="md-layout-item md-size-30 request-crossmatch">
                <loading-icon-text-button
                class="md-primary"
                @click="requestCrossMatch(possible_match)"
                icon="autorenew"
                :loading="isCrossMatchRequested"
                :disabled="isCrossMatchRequested || version != 'Current'">
                Request Cross-Match
                </loading-icon-text-button>
            </div>
            </div>
        </md-dialog-content>
        <md-dialog-actions>
            <md-button
            class="md-primary md-simple"
            @click="show_possible_matches_dialog = false"
            >Close</md-button
            >
        </md-dialog-actions>

        <md-snackbar
            :md-active.sync="snackbar.show"
            :md-duration="8000"
            class="editApplicantPossibleMatchSnackbar"
        >
            <span>
            <template v-if="snackbar.icon">
                <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
                &nbsp;&nbsp;&nbsp;
            </template>
            {{ snackbar.content }}
            </span>
            <md-button class="md-simple" @click="snackbar.show = false"
            >Dismiss</md-button
            >
        </md-snackbar>
        <md-dialog-alert
            class="editApplicantPossibleMatchErrorDialog"
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content"
        />
        </md-dialog>
        <!-- Possible Matches Dialog Ends -->

        <!-- Success Message -->
        <md-snackbar
            :md-active.sync="snackbar.show"
            :md-duration="8000"
            class="editApplicantPossibleMatchSnackbar"
        >
            <span>
            <template v-if="snackbar.icon">
                <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
                &nbsp;&nbsp;&nbsp;
            </template>
            {{ snackbar.content }}
            </span>
            <md-button class="md-simple" @click="snackbar.show = false"
            >Dismiss</md-button
            >
        </md-snackbar>

        <!-- Alert Dialog  -->
        <md-dialog-alert
            class="editApplicantPossibleMatchErrorDialog"
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content"
        />
    </div>
</template>
<script>
import TrafficLightCard from '@/components/Cards/TrafficLightCard.vue';
import TrafficLightItem from '@/components/Cards/TrafficLightItem.vue';
import veda from "@/components/utils/veda";
import filters from "@/components/utils/filters";
import { mapGetters } from "vuex";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import ConfirmDialog from "../Dialogs/ConfirmDialog";
import SendToPerfectScoreRequest from '@/components/SendToPerfectScoreRequest.vue';

export default {
  components: {
    LoadingIconTextButton,
    TrafficLightCard,
    TrafficLightItem,
    SendToPerfectScoreRequest
  },
  data(){
    return {
      abn_traffic_color: null,
      show_veda_details_dialog: false,
      show_possible_matches_dialog: false,
      current_veda_details_dialog_tab: 'veda-details-payday-enquiries',
      isCrossMatchRequested: false,
      isOriginalCreditReportRequested: false,
      showModal: true,
      error_dialog: {
        show: false,
        title: "",
        content: "",
      },
      snackbar: {
        show: false,
        icon: "done",
        content: "",
      },
    };
  },
  props: {
    vedaReport: {
      type: Object,
      required: true,
    },
    error: {
        type: Object,
        default: () => ({})
    },
    isFileBan: {
        type: Boolean,
        default: false
    },
    index: {
      type: [Number, String],
      default: 0,
    },
    showActionButtons: {
      type: Boolean,
      default: false,
    },
    showFullReportButton: {
      type: Boolean,
      default: true
    },
    showPerfectScoreButton: {
      type: Boolean,
      default: true
    },
    activeOneScoreButton: {
      type: Boolean,
      default: false
    },
    version:{
      type: String,
      default: 'Current'
    },
    showPerfectScoreButton: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapGetters({
      application: "application",
      userHasPermission: 'userHasPermission'
    }),
    abn() {
        return false;
    },
    directorships() {
        return this.vedaReport && this.vedaReport.user_details && this.vedaReport.user_details.directorships ? this.vedaReport.user_details.directorships.data : null;
    },
    fhis() {
        return this.vedaReport && this.vedaReport.user_details && this.vedaReport.user_details.fhis ? this.vedaReport.user_details.fhis.data : null;
    },
    computed_ccr_worst_status() {
      return this.ccr_worst_status(this.vedaReport.ccr);
    },
    computed_ccr_dates(){
      return this.ccr_dates(this.vedaReport.ccr);
    },
    computed_fhis_dates() {
      return this.fhis_dates(this.vedaReport.ccr);
    },
    report_pdf_url(){
      return this.vedaReport && this.vedaReport.enquiry_id ? `/document/credit_report/${this.vedaReport.enquiry_id}` : null;
    },
    anb_traffic_color(){
      return (this.vedaReport.abn.abn_traffic_light === 'GREEN' &&
          this.vedaReport.abn.abn_traffic_light === 'AMBER' &&
          this.vedaReport.abn.abn_traffic_light === 'RED') ?
        this.vedaReport.abn.abn_number :
        this.vedaReport.abn.abn_traffic_light;
    },
    hasFhisData() {
        return this.vedaReport?.user_details?.fhis?.data?.length > 0;
    }
  },
  methods: {
    ...veda,
    showVedaDetailsDialog(tab){
      this.show_veda_details_dialog = true;
      this.current_veda_details_dialog_tab = tab;
    },
    async get_veda_pdf(){
      try {
        let response = await axios.get(`/api/v1/application/getPdfFromVeda/${this.vedaReport.enquiry_id}`);
        if (response.data) {
          window.open(response.data)
        }
      } catch (e) {
        console.log(e);
      }
    },

    async show_possible_matches() {
      this.show_possible_matches_dialog = true;
    },

    async requestCrossMatch(possible_match) {
      try {
        if (this.version != 'Current') {
          return false;
        }
        const res = await this.showNotification(
          "Confirm",
          "This may incur an additional charge. Continue?",
          "Confirm",
          "Cancel"
        );
        if (!res) {
          return;
        }
        const possibleMatchId = possible_match.id;
        this.isCrossMatchRequested = true;
        let result = await this.$store.dispatch("request_cross_match", {
          application_data: this.application,
          applicant_index: this.index,
          possibleMatchId,
        });

        if (result["success"]) {
          this.showSuccessDialog("Crossmatch requested successfully.");
          this.show_possible_matches_dialog = false;
        } else {
          this.showErrorDialog(message);
        }
        this.isCrossMatchRequested = false;
      } catch (e) {
        if (e != null) {
          console.error(e, "error obj");
        }
        this.show_possible_matches_dialog = false;
        this.isCrossMatchRequested = false;
        this.$modal.show(ConfirmDialog, {
          title: "Error Cross Match Request",
          message: "Cross Match Request failed. Please try later...",
          confirmText: "Close",
        })
      }

    },

    async requestOriginalCreditReport(possibleMatchId) {
      const res = await this.showNotification(
        "Confirm",
        "This will revert back to original credit report - would you like to proceed?",
        "YES",
        "NO"
      );
      if (!res) {
        return res;
      }

      try {
        this.isOriginalCreditReportRequested = true;
        let result = await this.$store.dispatch("request_original_credit_report", {
          application_data: this.application,
          applicant_index: this.index,
          possibleMatchId,
        });

        if (result["success"]) {
          this.showSuccessDialog("Credit Report Reverted back to original successfully.");
        } else {
          this.showErrorDialog(message);
        }
        this.isOriginalCreditReportRequested = false;
      } catch (e) {
        console.log(e.response, "error obj");
        this.showErrorDialog(e.response.data);
      }

    },

    async requestCrossMatchCreditReport(possibleMatchId) {
      const res = await this.showNotification(
        "Confirm",
        "This will revert back to cross match credit report - would you like to proceed?",
        "YES",
        "NO"
      );
      if (!res) {
        return res;
      }

      try {
        this.isOriginalCreditReportRequested = true;
        let result = await this.$store.dispatch("request_original_credit_report", {
          application_data: this.application,
          applicant_index: this.index,
          possibleMatchId,
        });

        if (result["success"]) {
          this.showSuccessDialog("Credit Report Reverted back to original successfully.");
        } else {
          this.showErrorDialog(message);
        }
        this.isOriginalCreditReportRequested = false;
      } catch (e) {
        console.log(e.response, "error obj");
        this.showErrorDialog(e.response.data);
      }

    },

    showNotification(title, message, confirmText, cancelText = null) {
      return this.$modal.show(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },

    showErrorDialog(message, title = "Error") {
      this.error_dialog.show = true;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
    },

    showSuccessDialog(message) {
      this.snackbar.show = true;
      this.snackbar.icon = "done";
      this.snackbar.content = message;
    },

    formatFhisText(data_field_value) {
        if (data_field_value) {
            if (data_field_value.toLowerCase() === 'a') {
                return "A";
            } else if (data_field_value.toLowerCase() === 'v') {
                return "V";
            }
        }
        return "-";
    },

    getLast12MonthsOfFhis(repayment_history_v_status) {
        const last12Months = this.computed_fhis_dates;
        let dates = [];
        last12Months.forEach(element => {
            if (element.months && element.months.length) {
                element.months.forEach(month => {
                    dates.push(element.year + '-' + month);
                });
            }
        });

        let records = [];
        repayment_history_v_status.forEach(element => {
            if (dates.includes(element.period)) {
                records.push(element);
            }
        });

        return records;
    }
  },
  filters: {
    ...filters,
  },
};
</script>
<style scoped lang="scss">
  @import "../../assets/scss/theme.scss";

  .ccr_color{

    cursor: default;

    &.good    { color: $color-text; }
    &.neutral { color: $color-neutral; font-weight: bold; }
    &.bad     { color: $color-bad; font-weight: bold; }
    &.passive { color: $color-text-light; }
  }

  .tabs-with-title{

    margin-top: 8px;

  }

  ::v-deep .tabs-with-title > .md-tabs-navigation > .md-tab-nav-button:first-child{

    flex-grow: 1;
    opacity: 1;
    font-weight: bold;
    font-size: larger;
    color: $color-text-bold !important;

    & .md-ripple{
      justify-content: flex-start;
      padding-left: 0px;
    }

  }

  .dialog {
    z-index: 9998 !important;
  }

  .md-tooltip {
    z-index: 9999 !important;
  }
</style>
